export default {"src":"/_next/static/media/Glossary-Icon.fd4d9c01.svg","height":28,"width":28};